const ResponseStatus = {
  PENDING: "PENDING",
  CONFIRMED: "CONFIRMED",
  EXPIRED: "EXPIRED",
  FUTURE: "FUTURE",
  WAITING_PAYMENT: "WAITING_PAYMENT",
  WAITING_PARTIAL_PAYMENT: "WAITING_PARTIAL_PAYMENT",
  WAITING_PAYMENT_PIX: "WAITING_PAYMENT_PIX",
  WAITING_PAYMENT_BANK_SLIP: "WAITING_PAYMENT_BANK_SLIP",
  WAITING_PAYMENT_BOLEPIX: "WAITING_PAYMENT_BOLEPIX",
  WAITING_PAYMENT_DIRECT_DEBIT: "WAITING_PAYMENT_DIRECT_DEBIT",
  PRE_AUTHORIZATION_ERROR: "PRE_AUTHORIZATION_ERROR",
  PRE_AUTHORIZATION_WAITING: "PRE_AUTHORIZATION_WAITING",
  PRE_AUTHORIZED_BY_GATEWAY: "PRE_AUTHORIZED_BY_GATEWAY",
  CANCELLED_BY_GATEWAY: "CANCELED_BY_GATEWAY",
  CANCELLED_BY_GATEWAY_DEFINITIVE: "CANCELED_BY_GATEWAY_DEFINITIVE",
  REVERSED: "REVERSED",
  REVERSED_FAILED: "REVERSED_FAILED",
};

export default ResponseStatus;
